// extracted by mini-css-extract-plugin
export default {"sections":"iDhcX","section":"LoLyV","delimiter":"AwQqa ZdH1P","catalog":"aZYcR"};